/* ==========================================================================
   Follie by Alice - galleria scheda prodotto
   v1 2026-09-23: precarico slide vicine + salto immediato sul cambio colore.
   v2 2026-09-23: galleria "a finestra" per le schede con molte foto/video.
   v3 2026-09-23: scorrimento nativo iOS su touch (causa vera del crash).

   Problema: su iPhone (Safari e Chrome, entrambi WebKit) le schede con molte
   foto (FIOCCO 93, GLAMOUR 94) crashavano scorrendo la galleria. Ogni foto
   gia' vista restava decodificata in memoria (~14 MB l'una a 1600 px) e ogni
   video della galleria e della lente (4 elementi <video> 1080p su FIOCCO)
   veniva caricato anche se non visibile, con poster da 2500 px.

   Cosa fa:
   1. FINESTRA FOTO: tiene caricate solo la foto attiva, la precedente e le 2
      successive. Le foto lontane (oltre 3 posizioni) vengono "svuotate"
      (src -> gif trasparente) e il browser libera la memoria. Quando la
      cliente ci torna, la foto viene ricaricata dalla cache.
   2. VIDEO: un video viene caricato e riprodotto solo quando e' visibile
      (galleria o lente). Quando esce dallo schermo viene fermato e scaricato.
      Il poster da 2500 px viene sostituito con uno da 1080 px.
   3. CAMBIO COLORE su touch: salto immediato alla foto del colore invece di
      un'animazione che attraversa decine di foto.

   4. SCORRIMENTO NATIVO su touch (telefono/tablet): la galleria principale
      usa lo scorrimento nativo del browser (Swiper cssMode) invece di spostare
      con un'animazione tutta la striscia di slide. Con 93 foto la striscia era
      larga ~41.000 px (~123.000 px reali su iPhone): animarla mandava in crash
      il motore di Safari/Chrome iOS al primo o secondo swipe. Verificato su
      iPhone il 23/09 con la diagnostica (tema v5): FIOCCO e GLAMOUR non
      crashano piu'. Conseguenza: su touch la galleria non e' piu' "infinita"
      (dalla prima foto non si torna all'ultima). Desktop invariato.

   Memoria massima: ~7 foto + 1 video, indipendentemente da quante foto ha
   il prodotto.
   ========================================================================== */
(function () {
  'use strict';

  var GALLERY = 'media-gallery';
  var PLACEHOLDER =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  var LOAD_BEFORE = 1; /* slide precedenti caricate */
  var LOAD_AFTER = 2; /* slide successive caricate */
  var KEEP = 3; /* oltre questa distanza la slide viene svuotata */

  var isCoarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

  /* ------------------------------------------------ scorrimento nativo */
  /* Va applicato prima che il tema crei lo Swiper della galleria (avviene alla
     prima interazione o dopo il caricamento): questo script e' defer e gira
     subito dopo vendor.js, quindi in tempo. */
  if (isCoarse && window.Swiper && !window.Swiper.__follieNative) {
    var OrigSwiper = window.Swiper;
    var NativeSwiper = function (el, opts) {
      if (el && el.classList && el.classList.contains('swiper-main') && el.closest && el.closest(GALLERY)) {
        opts = Object.assign({}, opts, { cssMode: true, loop: false });
      }
      return new OrigSwiper(el, opts);
    };
    NativeSwiper.prototype = OrigSwiper.prototype;
    Object.setPrototypeOf(NativeSwiper, OrigSwiper);
    NativeSwiper.__follieNative = true;
    window.Swiper = NativeSwiper;
  }

  /* ------------------------------------------------------------ immagini */
  function stripImg(img) {
    if (img.hasAttribute('data-f-src')) return;
    var src = img.getAttribute('src');
    if (!src || src === PLACEHOLDER) return;
    img.setAttribute('data-f-src', src);
    if (img.hasAttribute('srcset')) {
      img.setAttribute('data-f-srcset', img.getAttribute('srcset'));
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', PLACEHOLDER);
  }

  function restoreImg(img) {
    if (!img.hasAttribute('data-f-src')) {
      if (img.loading === 'lazy') img.loading = 'eager';
      return;
    }
    if (img.hasAttribute('data-f-srcset')) {
      img.setAttribute('srcset', img.getAttribute('data-f-srcset'));
      img.removeAttribute('data-f-srcset');
    }
    img.loading = 'eager';
    img.setAttribute('src', img.getAttribute('data-f-src'));
    img.removeAttribute('data-f-src');
  }

  function slideImages(slide) {
    /* le immagini dentro <template> non sono nel DOM: querySelectorAll non le vede */
    return slide.querySelectorAll('img');
  }

  function mainSlides(gallery) {
    var wrapper = gallery.querySelector('swiper-component .swiper-main > .swiper-wrapper');
    if (!wrapper) return [];
    var out = [];
    for (var i = 0; i < wrapper.children.length; i++) {
      if (wrapper.children[i].classList.contains('swiper-slide')) out.push(wrapper.children[i]);
    }
    return out;
  }

  function activeIndex(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('swiper-slide-active')) return i;
    }
    return 0; /* Swiper non ancora inizializzato: la prima slide e' quella visibile */
  }

  function updateWindow(gallery) {
    var slides = mainSlides(gallery);
    var n = slides.length;
    if (n < 2) return;
    var active = activeIndex(slides);
    for (var i = 0; i < n; i++) {
      /* distanza circolare (la galleria e' in loop) */
      var d = i - active;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;
      var imgs = slideImages(slides[i]);
      var j;
      if (d >= -LOAD_BEFORE && d <= LOAD_AFTER) {
        for (j = 0; j < imgs.length; j++) restoreImg(imgs[j]);
      } else if (d < -KEEP || d > KEEP) {
        for (j = 0; j < imgs.length; j++) stripImg(imgs[j]);
      }
    }
  }

  /* --------------------------------------------------------------- video */
  function unloadVideo(v) {
    if (v.hasAttribute('data-f-unloaded')) return;
    try { v.pause(); } catch (e) {}
    var sources = v.querySelectorAll('source[src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('data-f-src', sources[i].getAttribute('src'));
      sources[i].removeAttribute('src');
    }
    if (v.hasAttribute('src')) {
      v.setAttribute('data-f-vsrc', v.getAttribute('src'));
      v.removeAttribute('src');
    }
    if (v.hasAttribute('poster')) {
      v.setAttribute('data-f-poster', v.getAttribute('poster'));
      v.removeAttribute('poster');
    }
    v.preload = 'none';
    v.setAttribute('data-f-unloaded', '');
    try { v.load(); } catch (e) {}
  }

  function loadVideo(v) {
    if (!v.hasAttribute('data-f-unloaded')) return;
    v.removeAttribute('data-f-unloaded');
    if (v.hasAttribute('data-f-poster')) {
      v.setAttribute('poster', v.getAttribute('data-f-poster').replace('_2500x.', '_1080x.'));
      v.removeAttribute('data-f-poster');
    }
    var sources = v.querySelectorAll('source[data-f-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-f-src'));
      sources[i].removeAttribute('data-f-src');
    }
    if (v.hasAttribute('data-f-vsrc')) {
      v.setAttribute('src', v.getAttribute('data-f-vsrc'));
      v.removeAttribute('data-f-vsrc');
    }
    v.preload = 'metadata';
    try { v.load(); } catch (e) {}
    if (v.autoplay || v.hasAttribute('autoplay')) {
      v.muted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  var videoObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) loadVideo(entry.target);
              else unloadVideo(entry.target);
            });
          },
          { threshold: 0.2 }
        )
      : null;

  function watchVideos(gallery) {
    var videos = gallery.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (v.hasAttribute('data-f-watched')) continue;
      v.setAttribute('data-f-watched', '');
      if (videoObserver) {
        unloadVideo(v); /* l'observer lo ricarica subito se e' visibile */
        videoObserver.observe(v);
      }
    }
  }

  /* ------------------------------------------------------------- aggancio */
  function hookSwiper(gallery) {
    var sc = gallery.querySelector('swiper-component');
    var sw = sc && sc.initSwiper;
    if (!sw || sw.__follieHooked || typeof sw.on !== 'function') return;
    sw.__follieHooked = true;
    var refresh = function () {
      updateWindow(gallery);
    };
    sw.on('slideChange', refresh);
    sw.on('slideChangeTransitionStart', refresh);
    sw.on('loopFix', refresh);
    refresh();
  }

  function setup(gallery) {
    if (!gallery || !gallery.querySelector('swiper-component')) return;
    updateWindow(gallery);
    watchVideos(gallery);
    hookSwiper(gallery);
  }

  function setupAll() {
    var galleries = document.querySelectorAll(GALLERY);
    for (var i = 0; i < galleries.length; i++) setup(galleries[i]);
  }

  /* Swiper si inizializza alla prima interazione e puo' essere ricreato:
     ricontrollo a ogni tocco e ogni secondo (costo trascurabile). */
  document.addEventListener(
    'touchstart',
    function (event) {
      var g = event.target && event.target.closest && event.target.closest(GALLERY);
      if (g) setup(g);
    },
    { capture: true, passive: true }
  );
  document.addEventListener(
    'pointerdown',
    function (event) {
      var g = event.target && event.target.closest && event.target.closest(GALLERY);
      if (g) setup(g);
    },
    { capture: true, passive: true }
  );
  setInterval(setupAll, 1000);

  /* Cambio variante: dopo il salto alla foto del colore aggiorna la finestra */
  document.addEventListener(
    'change',
    function (event) {
      var info = event.target && event.target.closest && event.target.closest('product-info');
      if (!info) return;
      setTimeout(function () {
        setup(info.querySelector(GALLERY));
      }, 150);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  /* Salto immediato sul cambio colore da touch */
  if (isCoarse && window.customElements && customElements.whenDefined) {
    customElements.whenDefined(GALLERY).then(function () {
      var Ctor = customElements.get(GALLERY);
      if (!Ctor || !Ctor.prototype || typeof Ctor.prototype.syncSlideshow !== 'function') return;
      if (Ctor.prototype.__follieInstantJump) return;
      var original = Ctor.prototype.syncSlideshow;
      Ctor.prototype.syncSlideshow = function (mediaElement, mediaIndex) {
        return original.call(this, mediaElement, mediaIndex, false);
      };
      Ctor.prototype.__follieInstantJump = true;
    });
  }
})();
